import { useState, useEffect, useRef } from "react";
import HeroSection from "./HeroSection";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { AiOutlineGlobal } from "react-icons/ai";
import { FaMapMarked } from "react-icons/fa";
import { FaChartSimple } from "react-icons/fa6";
import { FaMicrochip } from "react-icons/fa";
import { FaSatellite } from "react-icons/fa6";
import { FaSatelliteDish } from "react-icons/fa6";
import { IoRocket } from "react-icons/io5";

mapboxgl.accessToken = "pk.eyJ1Ijoic3ViaGFzbWl0YS1wcmFkaGFuIiwiYSI6ImNta2dwZDBodDBhNzUzZ3F4cGZiZDB4OXAifQ.xRNHRZQY-if4z7LP3ceOQA";


const offices = [
  {
    region: "North America",
    flag: "🇺🇸",
    country: "USA",
    address: "1312 17th Street Unit #229, Denver, CO 80202, United States",
    phone: "+17202639280",
    lat: 39.7503005,
    lng: -104.9966673,
    mapUrl:
      "https://www.google.com/maps/place/1312+17th+St+%23229,+Denver,+CO+80202,+USA/@39.7503005,-104.9992369,842m/data=!3m2!1e3!4b1!4m5!3m4!1s0x876c78db305fc9a7:0xc7a52cc0ba35f056!8m2!3d39.7503005!4d-104.9966673?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    region: "Asia Pacific",
    flag: "🇮🇳",
    country: "India - Hyderabad",
    address: "R R Towers, 4th Floor, Plot No. 188 & 189, Phase 11, Kavuri Hills, Madhapur, Hyderabad, Telangana 500033, India",
    phone: null,
    lat: 17.4373213,
    lng: 78.3785711,
    mapUrl:
      "https://www.google.com/maps/search/R+R+Towers,+4th+Floor,+Plot+No.+188+%26+189,+Phase+11,+Kavuri+Hills,+Madhapur,+Hyderabad,+Telangana+500033,+India/@17.4373213,78.3785711,4179m/data=!3m2!1e3!4b1?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇮🇳",
    country: "India - Delhi",
    address: "206, 2nd floor Allied House Building no.1, LSC Near Pushpa Bhawan, Saket New Delhi 110062",
    phone: null,
    lat: 28.5246202,
    lng: 77.1820192,
    mapUrl:
      "https://www.google.com/maps/search/206,+2nd+floor+Allied+House+Building+no.1,+LSC+Near+Pushpa+Bhawan,+Saket+New+Delhi+110062/@28.5246202,77.1820192,7689m/data=!3m2!1e3!4b1?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇮🇳",
    country: "India - Bhubaneswar",
    address: "GA 13, Sailashree Vihar, Khordha, Odisha, 751021",
    phone: null,
    lat: 20.3364364,
    lng: 85.7904731,
    mapUrl:
      "https://www.google.com/maps/search/GA+13,+Sailashree+Vihar,+Khordha,+Odisha,+751021/@20.3364364,85.7904731,11607m/data=!3m1!1e3?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇸🇬",
    country: "Singapore",
    address: "12 Marina Boulevard, #17-01 Tower 3, Marina Bay Financial Centre, Singapore 018982",
    phone: "+6565497044, +6565497001",
    lat: 1.2790221,
    lng: 103.8544967,
    mapUrl:
      "https://www.google.com/maps/place/MBFC+Tower+3/@1.2790221,103.8519271,1095m/data=!3m3!1e3!4b1!5s0x31da190fd645f1b5:0x7017a250d3c167f6!4m6!3m5!1s0x31da190e334a518f:0xcad303181bf53c50!8m2!3d1.2790221!4d103.8544967!16s%2Fg%2F1z264r2dn?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇲🇾",
    country: "Malaysia",
    address: " Level 28, The Gardens South Tower, Mid Valley City, Lingkaran Syed Putra, 59200 Kuala Lumpur, Malaysia",
    phone: null,
    lat: 3.1173993,
    lng: 101.6754828,
    mapUrl:
      "https://www.google.com/maps/place/Regus+-+Kuala+Lumpur,+The+Gardens/@3.1174207,101.6651831,4369m/data=!3m3!1e3!4b1!5s0x31cc09df42258ac7:0xd4f1421d98b283b2!4m6!3m5!1s0x31cc498ee708edff:0x76a3d798387ac123!8m2!3d3.1173993!4d101.6754828!16s%2Fg%2F11b7q4s3w5?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇵🇭",
    country: "Philippines",
    address: " Unit 301, 164 L. Gruet Street, Brgy Maytunas San Juan City, Philippines 1500",
    phone: null,
    lat: 14.5971806,
    lng: 121.0187338,
    mapUrl:
      "https://www.google.com/maps/search/+Unit+301,+164+L.+Gruet+Street,+Brgy+Maytunas+San+Juan+City,+Philippines+1500/@14.5971806,121.0187338,8479m/data=!3m2!1e3!4b1?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Asia Pacific",
    flag: "🇦🇺",
    country: "Australia",
    address: " 8 Beulah Road, Norwood SA 5067, Adelaide, Australia",
    phone: null,
    lat: -34.9188849,
    lng: 138.6238139,
    mapUrl:
      "https://www.google.com/maps/place/8+Beulah+Rd,+Norwood+SA+5067,+Australia/@-34.9188849,138.6212443,898m/data=!3m2!1e3!4b1!4m6!3m5!1s0x6ab0c948b2cc037d:0x25497971c5aa4199!8m2!3d-34.9188849!4d138.6238139!16s%2Fg%2F11c1zbhtbf?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },

  {
    region: "Global",
    flag: "UK",
    country: "United Kingdom",
    address: "8 61A, Bath Road, Reading, RG30 2BB, United Kingdom",
    phone: null,
    lat: 51.446929,
    lng: -1.0014178,
    mapUrl:
      "https://www.google.com/maps/search/8+61A,+Bath+Road,+Reading,+RG302+BB,+United+Kingdom/@51.446929,-1.0014178,387m/data=!3m1!1e3?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D",
  },
];

const logos = [
  "/partners/allo.png",
  "/partners/bristol-water.png",
  "/partners/cem.png",
  "/partners/edison.png",
  "/partners/psma.png",
  "/partners/sabah-electricity.png",
  "/partners/sarawak-energy.png",
  "/partners/scottish-water.png",
  "/partners/sp-group.png",
  "/partners/tenaga-nasional.png",
  "/partners/western-power.png",
  "/partners/yorkshire-water.png"
];



const industries = [
  {
    id: "telecom",
    label: "⚡ Telecom",
    title: "Telecom Network Intelligence",
    desc: "End-to-end OSS/BSS implementation, GIS-based network management, and fiber infrastructure digitization for modern telecom operators.",
    features: [
      "OSS/BSS platform implementation & integration",
      "Fiber & duct network GIS migration",
      "Workforce management for field teams",
      "Network performance analytics & dashboards",
    ],
    icon: "📡",
    stat1: { val: "40+", label: "Telecom Projects" },
    stat2: { val: "99.9%", label: "Migration Accuracy" },
  },
  {
    id: "utilities",
    label: "🔋 Utilities",
    title: "Smart Utility Operations",
    desc: "SCADA, ADMS, AMI, and GIS solutions for electricity, gas, and water utilities — enabling real-time network control and operational excellence.",
    features: [
      "SCADA & ADMS deployment for grid control",
      "AMI smart metering infrastructure",
      "GIS-based outage management (Energize & Deenergize)",
      "ArcGIS Utility Network migration",
    ],
    icon: "⚡",
    stat1: { val: "70-90%", label: "Migration Time Saved" },
    stat2: { val: "10", label: "Countries Served" },
  },
  {
    id: "transport",
    label: "🚛 Transportation",
    title: "Logistics & Transport Solutions",
    desc: "Field force management, route optimization, and geospatial analytics for transportation and logistics operators.",
    features: [
      "Fueerza field force management platform",
      "Real-time GPS tracking & route optimization",
      "GIS-based logistics intelligence",
      "Operational dashboards & reporting",
    ],
    icon: "🚛",
    stat1: { val: "24/7", label: "Platform Support" },
    stat2: { val: "ISO", label: "27001 Certified" },
  },
];

const services = [
  {
    icon: 
    <>
    <AiOutlineGlobal style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Managed Services",
    desc: "Cloud, DevOps, Service Desk & E2E managed IT operations with 24×7 support."
  },

  {
    icon: 
    <>
    <FaMapMarked  style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Geospatial Services (GIS)",
    desc: "Utility Network migration, geospatial data management, and advanced analytics."
  },

  {
    icon: 
    <>
    <FaChartSimple   style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "GIS Data Management",
    desc: "Big data lakes, enrichment, governance and AI-powered analytics platforms."
  },

  {
    icon: 
    <>
    <FaMicrochip    style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Telecom Data Management",
    desc: "Enterprise data migration, ETL pipelines and multi-system integration."
  },
];
const workflow = [
  {
    icon: 
    <>
    <FaSatellite    style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "GIS Assessment",
    desc: "Analyze utility networks, telecom infrastructure, spatial datasets, and operational requirements."
  },

  {
    icon: 
    <>
    <FaMapMarked  style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Network Design",
    desc: "Design GIS architectures, fiber routes, telecom mapping systems, and geospatial workflows."
  },

  {
     icon: 
    <>
    <FaSatelliteDish   style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Data Integration",
    desc: "Integrate telecom assets, GIS databases, spatial analytics, and enterprise platforms."
  },

  {
    icon: 
    <>
    <IoRocket   style={{ color:"rgb(249, 66, 0)" }}/>
    </>,
    title: "Deployment",
    desc: "Deploy scalable GIS and telecom solutions with validation, monitoring, and 24×7 support."
  }
];

export default function HomePage({ setActivePage }) {
  const cardsRef = useRef([]);
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [activeOffice, setActiveOffice] = useState(0);

  const selectedOffice = offices[activeOffice];
  useEffect(() => {
    if (!mapContainer.current) return;

    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center: [selectedOffice.lng, selectedOffice.lat],
        zoom: 13,
      });

      markerRef.current = new mapboxgl.Marker({color:"red"})
        .setLngLat([selectedOffice.lng, selectedOffice.lat])
        .addTo(mapRef.current);
    } else {
      mapRef.current.flyTo({
        center: [selectedOffice.lng, selectedOffice.lat],
        zoom: 13,
        essential: true,
      });

      markerRef.current.setLngLat([
        selectedOffice.lng,
        selectedOffice.lat,
      ]);
    }
  }, [activeOffice]);
  const [activeIndustry, setActiveIndustry] = useState("utilities");
  const industry = industries.find((i) => i.id === activeIndustry);

  return (
    <>
      {/* HERO */}
      {/* <HeroSection /> */}
      <HeroSection setActivePage={setActivePage} />

      {/* SCROLLING CLIENTS */}
      <div className="logo-slider">
      <div className="logo-track">
        {logos.concat(logos).map((logo, i) => (
          <img key={i} src={logo} alt="partner" />
        ))}
      </div>
    </div>

      {/* SERVICES OVERVIEW */}
      <section className="section" style={{ background: "#FAFAF8" }}>
        <div className="section-inner">
          <div className="section-header">
            <div className="section-tag">Our Services</div>
            <h2 className="section-title">End-to-End <span>Digital Solutions</span></h2>
            <p className="section-subtitle">From geospatial intelligence to managed cloud operations — we deliver mission-critical technology for the world's most demanding industries.</p>
          </div>
          <div className="grid-4">
            {services.map((s, i) => (
              <div key={i} className="card">
                <div className="card-icon">{s.icon}</div>
                <div className="card-title">{s.title}</div>
                <div className="card-text">{s.desc}</div>
              </div>
            ))}
          </div>

          {/* Technical Workflow */}
          <div style={{ marginTop: 60 }}>
            <div className="section-tag" style={{ marginBottom: 32 }}>How We Work</div>
            <h3 className="section-title" style={{ fontSize: "1.5rem", marginBottom: 48 }}>Technical <span>Workflow</span></h3>
            <div className="workflow-steps">
              {workflow.map((w, i) => (
                <div key={i} className="workflow-step">
                  <div className="ws-circle">{w.icon}</div>
                  <div className="ws-title">{w.title}</div>
                  <div className="ws-desc">{w.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section" style={{ background: "white", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
        <div className="section-inner">
          <div className="section-header">
            <div className="section-tag">Industries</div>
            <h2 className="section-title">Built for <span>Critical Industries</span></h2>
            <p className="section-subtitle">Sector-deep expertise across utilities, telecoms, transportation, and logistics.</p>
          </div>
          <div className="industry-tabs">
            {industries.map((ind) => (
              <button
                key={ind.id}
                className={`industry-tab${activeIndustry === ind.id ? " active" : ""}`}
                onClick={() => setActiveIndustry(ind.id)}
              >
                {ind.label}
              </button>
            ))}
          </div>
          <div className="industry-grid">
            <div className="industry-content">
              <h3 className="industry-title">{industry.title}</h3>
              <p className="industry-desc">{industry.desc}</p>
              <div className="industry-features">
                {industry.features.map((f, i) => (
                  <div key={i} className="industry-feature">
                    <span className="feature-check">✓</span>
                    <span>{f}</span>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 32, display: "flex", gap: 16 }}>
                <button className="btn-primary" onClick={() => setActivePage("services")}>Explore Services</button>
                <button className="btn-outline" onClick={() => setActivePage("contact")}>Get in Touch</button>
              </div>
            </div>
            <div className="industry-visual">
              <div className="industry-card-visual">
                <div className="industry-visual-icon">{industry.icon}</div>
                <div className="industry-visual-title">{industry.title}</div>
                <p style={{ fontSize: "0.88rem", color:"#0a1929", lineHeight: 1.6 }}>
                  {industry.desc}
                </p>
                <div className="industry-visual-stats">
                  <div className="ivs">
                    <div className="ivs-num">{industry.stat1.val}</div>
                    <div className="ivs-label">{industry.stat1.label}</div>
                  </div>
                  <div className="ivs">
                    <div className="ivs-num">{industry.stat2.val}</div>
                    <div className="ivs-label">{industry.stat2.label}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED PRODUCTS */}
   <section
  className="section"
  style={{
    backgroundImage: `url("/feature_product_bg.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
        <div className="section-inner">
          <div className="section-header">
            <div className="section-tag">Featured Products</div>
            <h2 className="section-title">Proprietary <span>Technology</span></h2>
            <p className="section-subtitle">Purpose-built platforms engineered for mission-critical utility and telecom environments.</p>
          </div>
          <div className="grid-2">
            {/* rUNr */}
            <div className="product-card">
              <div className="product-card-header">
                <div className="product-badge">Migration Platform</div>
                <div className="product-name">rUNr® – Automated Utility Network Migration Platform</div>
                <div className="product-tagline">Migrate with certainty. Operate with confidence.</div>
              </div>
              <div className="product-body">
                <p className="product-desc">rUNr® is Inovaantage’s proprietary enterprise-grade GIS migration platform, purpose-built to automate the migration of legacy ESRI Geometric Network and non-standard GIS datasets into the ESRI Utility Network with near-perfect accuracy.</p>
                <p className="product-desc">Designed for regulated utilities and telecom environments, rUNr enables organisations to modernise GIS infrastructure while reducing migration risk, operational disruption, and manual intervention.</p>

                <div className="product-features">
                  {["Automated Geometric Network to Utility Network migration", "Rule-driven data transformation & validation", "Connectivity, containment & association mapping", "Repeatable migration runs & controlled cutovers", "Audit-ready, production-grade migration framework"].map((f, i) => (
                    <div key={i} className="product-feature"><span className="pf-icon">→</span><span>{f}</span></div>
                  ))}
                </div>
                <button className="btn-primary" onClick={() => setActivePage("contact")}>Request Demo →</button>
              </div>
            </div>
            {/* ConduitPro */}
            <div className="product-card">
              <div className="product-card-header">
                <div className="product-badge">GIS Product</div>
                <div className="product-name">ConduitPro® – Intelligent Conduit & Utility Network Management Platform</div>
                <div className="product-tagline">Master conduit complexity. Unlock Utility Network value.</div>
              </div>
              <div className="product-body">
                <p className="product-desc">ConduitPro® is Inovaantage’s enterprise-grade conduit and duct network management platform, purpose-built for the ESRI Utility Network. It enables utilities and telecom operators to manage complex conduit hierarchies, maintain accurate cable and fiber associations, and improve operational visibility with scalable, Utility Network-native intelligence.</p>
                
                <div className="product-features">
                  {["Multi-level conduit & duct hierarchy management", "Association & containment intelligence", "Utility Network rule enforcement", "Data quality validation & governance" , " Seamless integration with ArcGIS Pro workflows"].map((f, i) => (
                    <div key={i} className="product-feature"><span className="pf-icon">→</span><span>{f}</span></div>
                  ))}
                </div>
                <button className="btn-primary" onClick={() => setActivePage("contact")}>Request Demo →</button>
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <button className="btn-outline" onClick={() => setActivePage("offerings")}>View All Products →</button>
          </div>
        </div>
      </section>

      {/* CHALLENGE VS SOLUTION */}
<section className="section" style={{ background: "", borderTop: "1px solid rgba(238, 146, 41, 0.92)" }}>
  <div className="section-inner">
    <div className="section-header">
      <div className="section-tag">Challenge vs. Solution</div>
      <h2 className="section-title">Why <span>Inovaantage</span></h2>
      <p className="section-subtitle">We solve the problems that generic IT vendors can't — because we're built for your industry.</p>
    </div>
   <div className="grid-2">
  {[
    {
      industry: "Telecom Solutions",
      icon: "ti-antenna-bars-5",
      title: "Network\nIntelligence",
      problem: "Manual, inconsistent mapping of fiber and duct infrastructure leads to planning errors and costly rework.",
      solution: "GIS-native conduit & duct management with ConduitPro® — fully integrated into ESRI Utility Network.",
    },
    {
      industry: "Logistics Optimization",
      icon: "ti-truck-delivery",
      title: "Field Force\nManagement",
      problem: "Disconnected field teams, manual scheduling, and zero real-time visibility across distributed operations.",
      solution: "Fueerza's intelligent field force management with live GPS tracking, automated dispatch, and mobile offline support.",
    },
  ].map((item, i) => (
    <div key={i} className="cvs-parent">
      <div className="cvs-card">
        <div className="cvs-glass"></div>
        <div className="cvs-logo">
          <span className="cvs-circle cvs-c1"></span>
          <span className="cvs-circle cvs-c2"></span>
          <span className="cvs-circle cvs-c3"></span>
          <span className="cvs-circle cvs-c4"></span>
          <span className="cvs-circle cvs-c5">
            <i className={`ti ${item.icon} cvs-icon-inner`} aria-hidden="true"></i>
          </span>
        </div>
        <div className="cvs-header">
          <div className="cvs-badge">{item.industry}</div>
          <div className="cvs-title">{item.title.split('\n').map((line, j) => (
            <span key={j}>{line}{j === 0 && <br />}</span>
          ))}</div>
        </div>
        <div className="cvs-bottom">
          <div className="cvs-row">
            <div className="cvs-block challenge">
              <div className="cvs-blabel">Challenge</div>
              <div className="cvs-btext">{item.problem}</div>
            </div>
            <div className="cvs-block solution">
              <div className="cvs-blabel">Solution</div>
              <div className="cvs-btext">{item.solution}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>
  </div>
</section>

      {/* ── OFFICES + MAP ────────────────────────────────────────────────── */}
      <section className="contact-offices-section" >
        <div className="section-inner">

          <div className="section-header">
            <div className="section-tag">Global Presence</div>
            <h2 className="section-title">Operating <span>Worldwide</span></h2>
            <p className="section-subtitle">With offices across 10 countries, we deliver 24/7 support wherever you are.</p>
          </div>

          <div className="contact-offices-layout">
            {/* Office Cards */}
            <div className="contact-office-list">
              {offices.map((office, i) => (
                <button
                  key={i}
                  ref={(el) => (cardsRef.current[i] = el)}
                  className={`contact-office-card contact-fade-up ${activeOffice === i ? "contact-office-card--active" : ""}`}
                  style={{ transitionDelay: `${i * 0.05}s` }}
                  onClick={() => setActiveOffice(i)}
                >
                  <div className="contact-office-card__top">
                    <span className="contact-office-card__flag">{office.flag}</span>
                    <div>
                      <p className="contact-office-card__region">{office.region}</p>
                      <h4 className="contact-office-card__country">{office.country}</h4>
                    </div>
                    {activeOffice === i && (
                      <span className="contact-office-card__badge">Selected</span>
                    )}
                  </div>
                  <p className="contact-office-card__addr">{office.address}</p>
                  {office.phone && (
                    <p className="contact-office-card__phone">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.37 11.5a19.79 19.79 0 01-3.07-8.67A2 2 0 012.48 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 8.9a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" /></svg>
                      {office.phone}
                    </p>
                  )}
                </button>
              ))}
            </div>

            {/* Map Panel */}
            <div className="contact-map-panel">
              <div className="contact-map-label">
                <span>{selectedOffice.flag}</span>
                <strong>{selectedOffice.country}</strong>
                <span className="contact-map-label__addr">{selectedOffice.address}</span>
              </div>
              <div className="contact-map-frame">
                <div
                  ref={mapContainer}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "20px",
                  }}
                />
              </div>
              <a
                href={selectedOffice.mapUrl}
                target="_blank"
                rel="noreferrer"
                className="contact-map-open"
              >
                Open in Google Maps
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                  <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="section">
        <div className="section-inner">
          <div className="section-tag" style={{ marginBottom: 32 }}>Client Testimonials</div>
          <div className="grid-3">
            {[
              { text: "Inovaantage delivered our ArcGIS Utility Network migration with exceptional precision. The rUNr platform reduced our timeline by over 75% with zero data loss." },
              { text: "The Fueerza platform transformed how we manage our 500+ field technicians. Real-time visibility and automated dispatch has improved productivity significantly." },
              { text: "Their SCADA and ADMS expertise is second to none. The team understands both the technology and the operational realities of running a distribution network." },
            ].map((t, i) => (
              <div key={i} className="testimonial-card">
                <p className="testimonial-text">{t.text}</p>
                <div className="testimonial-author">{t.author}</div>
                <div className="testimonial-company">{t.company}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}